import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CrossSellIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CrossSell",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8.57 32c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.71a1.71 1.71 0 1 0-.002 3.418 1.71 1.71 0 0 0 .002-3.418M25.71 32c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.71a1.71 1.71 0 1 0-.002 3.418 1.71 1.71 0 0 0 .002-3.418M26.29 21.72H8c-1.89 0-3.43-1.54-3.43-3.43V8c0-.63-.51-1.14-1.14-1.14H1.14a1.14 1.14 0 1 1 0-2.28h2.29c1.89 0 3.43 1.54 3.43 3.43V18.3c0 .63.51 1.14 1.14 1.14h18.29c.63 0 1.14-.51 1.14-1.14v-5.71H10.29a1.14 1.14 0 1 1 0-2.28h18.29c.63 0 1.14.51 1.14 1.14v6.86c0 1.89-1.54 3.43-3.43 3.43Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.57 17.72c-.63 0-1.14-.51-1.14-1.14V1.16a1.14 1.14 0 1 1 2.28 0v15.41c0 .63-.51 1.14-1.14 1.14Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.14 6.88c-.29 0-.58-.11-.81-.33l-3.76-3.76-3.76 3.76c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62L16.76.36c.43-.43 1.19-.43 1.62 0l4.57 4.57a1.14 1.14 0 0 1-.81 1.95"
    })]
  }));
};
CrossSellIcon.displayName = 'CrossSellIcon';